<template>
    <div class="clientWndTool">
        <a class="btnWnd btnWndMin"
           href="javascript:;"
           @click="fnBtnClick('wndMin')">
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="10px"
                 height="2px">
                <path fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M-0.000,-0.000 L10.000,-0.000 L10.000,2.000 L-0.000,2.000 L-0.000,-0.000 Z" />
            </svg>
        </a>
        <a class="btnWnd btnWndNmlMax"
           href="javascript:;"
           @click="fnBtnClick('wndNmlMax')"
           :class="classWndNmlMax">
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="13px"
                 height="11px"
                 v-if="!wndNmlMax">
                <path fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M-0.000,11.000 L-0.000,-0.000 L13.000,-0.000 L13.000,11.000 L-0.000,11.000 ZM11.000,2.000 L2.000,2.000 L2.000,9.000 L11.000,9.000 L11.000,2.000 Z" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="11px"
                 height="10px"
                 v-else>
                <path fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M10.000,7.000 L8.000,7.000 L8.000,9.000 L8.000,10.000 L7.000,10.000 L1.000,10.000 L-0.000,10.000 L-0.000,9.000 L-0.000,5.000 L-0.000,3.000 L3.000,3.000 L3.000,2.000 L3.000,0.000 L4.000,0.000 L11.000,0.000 L11.000,1.000 L11.000,2.000 L11.000,6.000 L11.000,7.000 L10.000,7.000 ZM1.000,5.000 L1.000,9.000 L7.000,9.000 L7.000,5.000 L1.000,5.000 ZM10.000,2.000 L4.000,2.000 L4.000,3.000 L8.000,3.000 L8.000,5.000 L8.000,6.000 L10.000,6.000 L10.000,2.000 Z" />
            </svg>
        </a>
        <a class="btnWnd btnWndClose"
           href="javascript:;"
           @click="fnBtnClick('wndClose')">
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="10px"
                 height="10px">
                <path fill-rule="evenodd"
                      fill="rgb(136, 136, 136)"
                      d="M8.000,6.000 L8.000,7.000 L9.000,7.000 L9.000,8.000 L10.000,8.000 L10.000,10.000 L8.000,10.000 L8.000,9.000 L7.000,9.000 L7.000,8.000 L6.000,8.000 L6.000,7.000 L4.000,7.000 L4.000,8.000 L3.000,8.000 L3.000,9.000 L2.000,9.000 L2.000,10.000 L-0.000,10.000 L-0.000,8.000 L1.000,8.000 L1.000,7.000 L2.000,7.000 L2.000,6.000 L3.000,6.000 L3.000,4.000 L2.000,4.000 L2.000,3.000 L1.000,3.000 L1.000,2.000 L-0.000,2.000 L-0.000,0.000 L2.000,0.000 L2.000,1.000 L3.000,1.000 L3.000,2.000 L4.000,2.000 L4.000,3.000 L6.000,3.000 L6.000,2.000 L7.000,2.000 L7.000,1.000 L8.000,1.000 L8.000,0.000 L10.000,0.000 L10.000,2.000 L9.000,2.000 L9.000,3.000 L8.000,3.000 L8.000,4.000 L7.000,4.000 L7.000,6.000 L8.000,6.000 Z" />
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    name: 'clientWndTool',
    data () {
        return {
            txtWndMin: '最小化',
            txtWndNmlMax: '最大化',
            txtWndClose: '关闭',
            txtFullScreen: '全屏',
            classWndNmlMax: 'classWndNml',
            wndNmlMax: true,
            isHall: false
        }
    },
    props: {
        ish5: {
            type: String,
            default: 'web'
        }
    },
    components: {
    },
    computed: {
    },
    watch: {
    },
    created () {
        if (window.screen.availWidth > window.innerWidth) {
            this.wndNmlMax = false
        }
    },
    mounted () {
        // 大厅判断逻辑
        this.fnCefGameBox({
            method: 'IsHall',
            success: res => {
                if (res.data.isHall === 1) {
                    this.isHall = true
                } else {
                    this.isHall = false
                }
            }
        })
        window.CCJS = this.CCJS
    },
    methods: {
        CCJS (e) {
            switch (e.method) {
                case 'wndResize':
                    if (e.data.change_type === 1 || e.data.change_type === 2) {
                        this.wndNmlMax = true
                    } else {
                        this.wndNmlMax = false
                    }
                    break
            }
        },
        // 按钮点击事件
        fnBtnClick (o) {
            const t = this
            switch (o) {
                case 'wndMin':
                    t.fnCefGameBox({
                        method: 'clientWndMin',
                        success: function (res) {
                            // t.log(res)
                        }
                    })
                    t.DSP.click({
                        type: 3,
                        pars: '',
                        url: location.href,
                        sourcename: '最小化',
                        id: 1001,
                        page_block_id: 1,
                        x_position: event.clientX,
                        y_position: event.clientY
                    })
                    break
                case 'wndNmlMax':
                    t.wndNmlMax = !this.wndNmlMax
                    if (t.wndNmlMax) {
                        t.classWndNmlMax = 'classWndMax'
                    } else {
                        t.classWndNmlMax = 'classWndNml'
                    }
                    t.fnCefGameBox({
                        method: 'clientWndNmlMax',
                        success: function (res) {
                            t.$emit('fnBtnClick', 'wndNmlMax', t.wndNmlMax)
                        }
                    })
                    t.DSP.click({
                        type: 3,
                        pars: '',
                        url: location.href,
                        sourcename: t.classWndNmlMax ? '最大化' : '还原',
                        id: 1002,
                        page_block_id: 1,
                        x_position: event.clientX,
                        y_position: event.clientY
                    })
                    break
                case 'wndClose':
                    if (this.ish5 === 'h5') {
                        this.$emit('fnBtnClick', 'wndClose')
                        return
                    }
                    if (t.$route.name === 'PageBrowser') {
                        t.Storage.del('wndBrowser')
                        t.fnCefGameBox({
                            method: 'SendJsMsg',
                            data: {
                                method: 'wndClearBrowserUrl'
                            },
                            success () {
                                t.fnCefGameBox({
                                    method: 'clientWndClose'
                                })
                            }
                        })
                    } else if (t.$route.name === 'GamePlay') {
                        t.$emit('fnBtnClick', 'wndClose')
                        // t.fnCefGameBox({
                        //   method: 'SendJsMsg',
                        //   data: {
                        //     method: 'wndGameClose'
                        //   },
                        //   success () {
                        //     t.fnCefGameBox({
                        //       method: 'clientWndClose',
                        //       data: {
                        //         method: 'wndClose'
                        //       }
                        //     })
                        //   }
                        // })
                    } else {
                        if (this.isHall) {
                            this.$emit('fnBtnClick', 'wndClose')
                        } else {
                            t.fnCefGameBox({
                                method: 'clientWndClose',
                                data: {
                                    method: 'wndClose'
                                }
                            })
                        }
                    }
                    t.DSP.click({
                        type: 12,
                        pars: '',
                        url: location.href,
                        sourcename: '关闭',
                        id: 1003,
                        page_block_id: 1,
                        x_position: event.clientX,
                        y_position: event.clientY
                    })
                    break
            }
        }
    }
}
</script>

<style scoped>
</style>
